import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-bautagebuch-gu-workspace',
  templateUrl: './bautagebuch-gu-workspace.component.html',
  styleUrls: ['./bautagebuch-gu-workspace.component.scss']
})
export class BautagebuchGuWorkspaceComponent {}
